import Controller, { OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { FragmentNames, VitalSignAndRespiratoryMonitoringAliases } from '../../../codegen';
import BaseController from '../../BaseController';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';
import { TabControlAPI, TabWithContentAPI } from '@philips-internal/oswald-ui-components';
import { FoundationUtils } from '../../../utils/foundation-utils';
import { FunctionName, PEP_9127Parameters } from '../../../utils/parameters';
import { VitalSignRootService } from './vital-sign-root-service';
import { YesNoType } from '../../../utils/enum-utils';
import { VitalSignRespiratoryMonitoringTabs } from './vital-sign-respiratory-monitoring-types';

@Controller({ fragment: FragmentNames.VITAL_SIGN_AND_RESPIRATORY_MONITORING })
class VitalSignRespiratoryMonitoringController extends BaseController {

  @Inject(VitalSignAndRespiratoryMonitoringAliases.TAB_CONTROL)
  private tabControlApi!: TabControlAPI;

  @Inject(VitalSignAndRespiratoryMonitoringAliases.TAB_WITH_CONTENT_RESPIRATORY_MONITORING)
  private tabRespiratoryMonitoringApi!: TabWithContentAPI;

  @Inject(VitalSignAndRespiratoryMonitoringAliases.TAB_WITH_CONTENT_VITAL_SIGN)
  private tabVitalSignApi!: TabWithContentAPI;

  private readonly isAllowedVitalSigns = (FoundationUtils.findModuleParam(FunctionName.PEP_9127, PEP_9127Parameters.ALLOW_ACESS_VITAL_SIGN) as string) === YesNoType.YES;
  private readonly isAllowedRespiratoryMonitoring = (FoundationUtils.findModuleParam(FunctionName.PEP_9127, PEP_9127Parameters.ALLOW_ACCESS_RESPIRATORY_MONITORING) as string) === YesNoType.YES;

  @OnMount({ target: VitalSignAndRespiratoryMonitoringAliases.LAYOUT_VITAL_SIGN_AND_RESPIRATORY_MONITORING })
  onMount(): void {
    InformationBarUtils.collapsedBar = true;
    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();

    if (this.isAllowedRespiratoryMonitoring && this.isAllowedVitalSigns || !this.isAllowedRespiratoryMonitoring && this.isAllowedVitalSigns) {
      this.tabControlApi.setActiveTab(VitalSignRespiratoryMonitoringTabs.VITAL_SIGN);
    } else if (this.isAllowedRespiratoryMonitoring && !this.isAllowedVitalSigns) {
      this.tabControlApi.setActiveTab(VitalSignRespiratoryMonitoringTabs.RESPIRATORY_MONITORING);
    }

    this.context.set({ encounterId, patientId });
    const currentTab = VitalSignRootService.currentTab;
    currentTab && this.tabControlApi.setActiveTab(VitalSignRootService.currentTab);
  }

  @OnMount(VitalSignAndRespiratoryMonitoringAliases.TAB_WITH_CONTENT_RESPIRATORY_MONITORING)
  onMountTabWithContentRespiratoryMonitoring(): void {
    if (this.isAllowedRespiratoryMonitoring) {
      this.tabRespiratoryMonitoringApi.setVisible(true)
      this.tabRespiratoryMonitoringApi.setActiveTab(VitalSignRespiratoryMonitoringTabs.RESPIRATORY_MONITORING)
    }
  }

  @OnMount(VitalSignAndRespiratoryMonitoringAliases.TAB_WITH_CONTENT_VITAL_SIGN)
  onMountTabWithContentVitalSign(): void {
    if (this.isAllowedVitalSigns) {
      this.tabVitalSignApi.setVisible(true)
      this.tabVitalSignApi.setActiveTab(VitalSignRespiratoryMonitoringTabs.VITAL_SIGN)
    }
  }

  @OnUnmount(VitalSignAndRespiratoryMonitoringAliases.TAB_CONTROL)
  handleUnmountTabControl(): void {
    VitalSignRootService.currentTab = this.tabControlApi.getActiveTab();
  }
}

export default VitalSignRespiratoryMonitoringController;
